<script>
/**
 * BottomNav
 * ---------------------------------------------------------------------------
 * Barra de navegación inferior para móvil (estilo apps modernas), visible solo
 * en < lg (992px) vía `d-lg-none`. Accesos rápidos a los módulos más usados +
 * botón "Más" que abre el drawer lateral que YA trae el template Skote
 * (clase `sidebar-enable` en el body).
 *
 * Solo presentación/navegación: no toca lógica de negocio.
 */
export default {
  name: "BottomNav",
  data() {
    return {
      links: [
        { label: "Inicio", icon: "bx bx-home-alt", to: "/" },
        { label: "Ventas", icon: "bx bx-cart", to: "/ventas/venta" },
        { label: "Productos", icon: "bx bx-box", to: "/inventario/productos" },
        { label: "Taller", icon: "bx bx-wrench", to: "/ventas/taller" },
      ],
    };
  },
  methods: {
    isActive(to) {
      if (to === "/") return this.$route.path === "/";
      return this.$route.path.startsWith(to);
    },
    abrirMenu() {
      document.body.classList.toggle("sidebar-enable");
    },
  },
};
</script>

<template>
  <nav class="rwd-bottomnav d-lg-none">
    <router-link
      v-for="(l, i) in links"
      :key="i"
      :to="l.to"
      class="rwd-bn-item"
      :class="{ 'rwd-bn-item--active': isActive(l.to) }"
    >
      <i :class="l.icon"></i>
      <span>{{ l.label }}</span>
    </router-link>
    <a href="javascript:void(0)" class="rwd-bn-item" @click="abrirMenu">
      <i class="bx bx-menu"></i>
      <span>Más</span>
    </a>
  </nav>
</template>

<style scoped>
.rwd-bottomnav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1030;
  display: flex;
  align-items: stretch;
  background: #ffffff;
  border-top: 1px solid #e7e9ef;
  box-shadow: 0 -2px 10px rgba(16, 42, 76, 0.06);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
.rwd-bn-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 8px 2px;
  font-size: 10px;
  color: #74788d;
  text-decoration: none;
  transition: color 0.15s ease;
}
.rwd-bn-item i {
  font-size: 20px;
  line-height: 1;
}
.rwd-bn-item--active {
  color: #1b6ec2;
  font-weight: 600;
}
.rwd-bn-item--active i {
  color: #1b6ec2;
}
</style>
